export default "__VITE_ASSET__DkLq2nFL__"